module.exports = __webpack_public_path__ + "static/media/backIcon.cf7f3c09.svg";